import './style.css';
import { Map, View } from 'ol';

import { OSM, TileDebug, XYZ, Vector as VectorSource, Stamen } from 'ol/source';
import { register } from 'ol/proj/proj4';
import proj4 from "proj4";
import { applyTransform } from 'ol/extent';
import { get as getProjection, getTransform } from 'ol/proj';
import TileGrid from 'ol/tilegrid/TileGrid';
import { createXYZ } from 'ol/tilegrid';
import { getRenderPixel } from 'ol/render.js';
import { getVectorContext } from 'ol/render.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import { Fill, Style } from 'ol/style.js';

proj4.defs("EPSG:2136", "+proj=tmerc +lat_0=4.66666666666667 +lon_0=-1 +k=0.99975 +x_0=274319.739163358 +y_0=0 +a=6378300 +rf=296 +towgs84=-170,33,326,0,0,0,0 +to_meter=0.304799710181509 +no_defs +type=crs");
proj4.defs("EPSG:7416", "+proj=utm +zone=32 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs");
register(proj4);
const projEpsg = "EPSG:7416";
const newProj = getProjection(projEpsg);
const fromLonLat = getTransform('EPSG:4326', newProj);
const projExt = [8.0, 57.8, 13.01, 54.51]
const extent = applyTransform(projExt, fromLonLat, undefined, 8);
newProj.setExtent(extent);





//const pixelSize = 0.007850169999998;

//const Upper_Left = [687805.588, 6122302.002] //(8d19'36.50"E, 56d22'55.12"N)
//const Lower_Left = [687805.588, 6122086.169] //(8d19'36.79"E, 56d22'38.87"N)
//const Upper_Right = [688119.186, 6122302.002] //(8d20'12.17"E, 56d22'55.31"N)
//const Lower_Right = [688119.186, 6122086.169] //(8d20'12.45"E, 56d22'39.06"N)
//const Center = [687962.387, 6122194.086];// (8d19'54.48"E, 56d22'47.09"N)

function createEarthMLLayer(pixelSize,maxzoom, Lower_Left, Upper_Right, tileid) {
    var bbox = [Lower_Left[0], Lower_Left[1], Upper_Right[0], Upper_Right[1]];

    const zooms = Array.from({ length: 7 }, (_, i) => i + (maxzoom - 8 + 2)); //[2, 3, 4, 5, 6, 7, 8];

    var tilgrid = createXYZ({
        extent: bbox.slice(),
        maxResolution: Math.pow(2, maxzoom)* pixelSize, // * 2 * 2 * 2 * 2 * 2 * 2 * 2 * 2,
        minZoom: zooms[0],
        maxZoom: zooms[zooms.length - 2]

    });

    const layer1 = new TileLayer({
        extent: bbox,

        source: new XYZ({
            projection: newProj,

            tileGrid: tilgrid,
            url: '/' + tileid + '/{z}/{y}/{x}.png'
        }),
    });

    return layer1;
};
 
const newView = new View({
    projection: newProj,
    center: [687962.387, 6122194.086],
    zoom: 12,
    // extent: bbox.slice()
});

const layer1 = createEarthMLLayer(0.007850169999998,8, [687805.588, 6122086.169], [688119.186, 6122302.002],'taageskovvej30-29apr2023');
const layer2 = createEarthMLLayer(0.008231859999996,8, [687795.410, 6122109.023], [688093.214, 6122300.900], 'taageskovvej30-8maj2023');

function createlayer(id) {


    return fetch('/'+id, {
        method: "GET"

    }).then(inforsp => inforsp.json().then(layerinfo => {
        console.log(layerinfo);
        return createEarthMLLayer(layerinfo.pixelSize, layerinfo.maxZoom, layerinfo.lowerLeft, layerinfo.upperRight, id)
    }));
}



const swipe = document.getElementById('swipe');
//const osm = new TileLayer({
//    source: new OSM()
//});
const background = new TileLayer({
    className: 'stamen2',
   // maxZoom:17,
    source: new OSM()
});
const map = new Map({
    target: 'map',
    layers: [background,
     //osm   
        //new TileLayer({
        // //   extent: [center[0] - buffer_meter, center[1] - buffer_meter, center[0] + buffer_meter, center[1] + buffer_meter],
        //    projection: "EPSG:2136",
        //    source: new TileDebug({
        //        projection: "EPSG:2136",
        //        wrapX:true,
        //        tileGrid: tilgrid
        //    }),
        //}),

        //layer1,
        //layer2

    ],
    view: newView
    //view: new View({
    //  center: [0, 0],
    //  zoom: 2
    //})
});
//newView.fit(extent);
//createlayer('taageskovvej30-11jun2022').then(layer => {

//    console.log(map);
//    map.addLayer(layer);
//});
const boundary = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": {},
            "geometry": {
                "coordinates": [
                    [
                        [
                            11.951758482766877,
                            55.21051273091686
                        ],
                        [
                            11.952034635592518,
                            55.20996043338753
                        ],
                        [
                            11.955651564120885,
                            55.20997910022486
                        ],
                        [
                            11.956327032008943,
                            55.21008670583694
                        ],
                        [
                            11.956261602089967,
                            55.2106664501882
                        ],
                        [
                            11.955969091775046,
                            55.2107411136202
                        ],
                        [
                            11.955768953137692,
                            55.211195679140076
                        ],
                        [
                            11.951758482766877,
                            55.21051273091686
                        ]
                    ]
                ],
                "type": "Polygon"
            }
        }
    ]
};

const format = new GeoJSON({
    featureProjection: 'EPSG:7416',
   
})
const clipLayer = new VectorLayer({
    style: null,
    source: new VectorSource({
         
        format: format
    }),
});
//clipLayer.getSource().on('addfeature', function (e) {
//    console.log("Adding Feature", arguments);
//    console.log(clipLayer.getSource().getFeatures()[0].getGeometry());
//    osm.setExtent(clipLayer.getSource().getExtent());
//});
clipLayer.getSource().addFeatures(format.readFeatures(boundary));
const style = new Style({
    fill: new Fill({
        color: 'black',
    }),
});

//osm.on('postrender', function (event) {
//    const vectorContext = getVectorContext(event);
//    event.context.globalCompositeOperation = 'destination-in';
//    clipLayer.getSource().forEachFeature(function (feature) {
//        vectorContext.drawFeature(feature, style);
//    });
//    event.context.globalCompositeOperation = 'source-over';

   
//});

const left = document.getElementById('right');
const right = document.getElementById('left');


function onDropDownChange() {
    console.log(map);
    Promise.all([createlayer(right.value), createlayer(left.value)])
        .then(layers => {



            const layer2 = layers[layers.length - 1];

            layer2.on('prerender', function (event) {
                const ctx = event.context;
                const mapSize = map.getSize();
                const width = mapSize[0] * (swipe.value / 100);
                const tl = getRenderPixel(event, [width, 0]);
                const tr = getRenderPixel(event, [mapSize[0], 0]);
                const bl = getRenderPixel(event, [width, mapSize[1]]);
                const br = getRenderPixel(event, mapSize);

                ctx.save();
                ctx.beginPath();
                ctx.moveTo(tl[0], tl[1]);
                ctx.lineTo(bl[0], bl[1]);
                ctx.lineTo(br[0], br[1]);
                ctx.lineTo(tr[0], tr[1]);
                ctx.closePath();

                ctx.clip();
            });

            layer2.on('postrender', function (event) {
                //const vectorContext = getVectorContext(event);
                //event.context.globalCompositeOperation = 'destination-in';
                //clipLayer.getSource().forEachFeature(function (feature) {
                //    vectorContext.drawFeature(feature, style);
                //});
                //event.context.globalCompositeOperation = 'source-over';

                const ctx = event.context;
                ctx.restore();
            });

            layer2.on('postrender', function (event) {
                const vectorContext = getVectorContext(event);
                event.context.globalCompositeOperation = 'destination-in';
                clipLayer.getSource().forEachFeature(function (feature) {
                    vectorContext.drawFeature(feature, style);
                });
                event.context.globalCompositeOperation = 'source-over';

            });

            layers[0].on('postrender', function (event) {
                const vectorContext = getVectorContext(event);
                event.context.globalCompositeOperation = 'destination-in';
                clipLayer.getSource().forEachFeature(function (feature) {
                    vectorContext.drawFeature(feature, style);
                });
                event.context.globalCompositeOperation = 'source-over';

            });

            map.setLayers([background,...layers]);
          //  layers[0].setExtent(clipLayer.getSource().getExtent());
        //    layer2.setExtent(clipLayer.getSource().getExtent());
        })
}
left.addEventListener("change", onDropDownChange);
right.addEventListener("change", onDropDownChange);
onDropDownChange();
swipe.addEventListener('input', function () {
    map.render();
});